import React, { useEffect, useRef, useState } from 'react';

interface UseImagePreloaderParams {
  imageSrc: string;
  sideViewImageSrc: string;
}

interface UseImagePreloaderResult {
  frontBlobUrl: string;
  sideBlobUrl: string;
}

export const useImagePreloader = ({
  imageSrc,
  sideViewImageSrc,
}: UseImagePreloaderParams): UseImagePreloaderResult => {
  const [frontBlobUrl, setFrontBlobUrl] = useState('');
  const [sideBlobUrl, setSideBlobUrl] = useState('');
  const frontBlobRef = useRef('');
  const sideBlobRef = useRef('');

  useEffect(() => {
    let cancelled = false;

    const preload = (
      url: string,
      setBlob: (u: string) => void,
      blobRef: React.MutableRefObject<string>,
    ) => {
      if (!url) return;
      fetch(url)
        .then(res => res.blob())
        .then(blob => {
          if (cancelled) return;
          const objectUrl = URL.createObjectURL(blob);
          blobRef.current = objectUrl;
          setBlob(objectUrl);
        })
        .catch(() => { /* fall back to original URL */ });
    };

    preload(imageSrc, setFrontBlobUrl, frontBlobRef);
    preload(sideViewImageSrc, setSideBlobUrl, sideBlobRef);

    return () => {
      cancelled = true;
      if (frontBlobRef.current) { URL.revokeObjectURL(frontBlobRef.current); frontBlobRef.current = ''; }
      if (sideBlobRef.current) { URL.revokeObjectURL(sideBlobRef.current); sideBlobRef.current = ''; }
    };
  }, [imageSrc, sideViewImageSrc]);

  return { frontBlobUrl, sideBlobUrl };
};
